import { Injectable } from '@nestjs/common';
import { VehicleAssignment } from '../vehicle-assignment.entity';
import { VehicleAssignmentDto } from './vehicle-assignment.dto';
let moment = require('moment');
@Injectable()
export class VehicleAssignmentAdapter {
  
  public convertDtoToEntity(  vehicleAssignmentDto: VehicleAssignmentDto,  isUpdate: boolean = false ): VehicleAssignment {
    const vehicleAssignment = new VehicleAssignment();

    vehicleAssignment.vehicleAssignId=vehicleAssignmentDto.vehicleAssignId;
    vehicleAssignment.vehicleId=vehicleAssignmentDto.vehicleId;
    vehicleAssignment.driverId=vehicleAssignmentDto.driverId;
    vehicleAssignment.harvestingDate=moment(vehicleAssignmentDto.harvestingDate).format('YYYY-MM-DD');
    vehicleAssignment.harvestingTime=vehicleAssignmentDto.harvestingTime;
    vehicleAssignment.assignedDate= new Date();
    vehicleAssignment.indentId=vehicleAssignmentDto.indentId;
    vehicleAssignment.isActive=vehicleAssignmentDto.isActive==undefined?true:vehicleAssignmentDto.isActive;
    if (isUpdate) {
      vehicleAssignment.updatedUser = vehicleAssignmentDto.updatedUser;
    } else {
      vehicleAssignment.isActive = true;
      vehicleAssignment.createdUser = vehicleAssignmentDto.createdUser;
    }
   return vehicleAssignment;
  }
  public convertEntityToDto(vehAssignmentObject: VehicleAssignment): VehicleAssignmentDto {
    const vehicleAssignmentDto= new VehicleAssignmentDto;
    vehicleAssignmentDto.vehicleAssignId = vehAssignmentObject.vehicleAssignId;
    vehicleAssignmentDto.vehicleId = vehAssignmentObject.vehicleId;
    vehicleAssignmentDto.driverId = vehAssignmentObject.driverId;
    vehicleAssignmentDto.harvestingTime = vehAssignmentObject.harvestingTime;
    vehicleAssignmentDto.harvestingDate = vehAssignmentObject.harvestingDate;
    vehicleAssignmentDto.indentId = vehAssignmentObject.indentId;
    vehicleAssignmentDto.assignedDate = vehAssignmentObject.assignedDate;
    vehicleAssignmentDto.isActive = vehAssignmentObject.isActive;
    vehicleAssignmentDto.createdAt = vehAssignmentObject.createdAt;
    vehicleAssignmentDto.updatedAt = vehAssignmentObject.updatedAt;
    vehicleAssignmentDto.createdUser = vehAssignmentObject.createdUser;
    vehicleAssignmentDto.updatedUser = vehAssignmentObject.updatedUser;
    vehicleAssignmentDto.versionFlag = vehAssignmentObject.versionFlag;
    return vehicleAssignmentDto;
  }
}
